import React from "react";
import HierarchicPieChart from "../../../../components/charts/HierarchicPieChart/HierarchicPieChart";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./StatsViews.styles";
import { StatsTable } from "../StatsTable";
import { useSelector } from "react-redux";
import { IStatsFilters } from "../StatsFilter/StatsFilter";
import { IColumnMapping } from "../../../../components/CsvExport/CsvExportButton";
import { convertDateToFullDateTime } from "../../../../../utilities/dateTimeUtils";
import { IUniversalTableColumn } from "../../../../components/UniversalTable/interfaces";

const dataColumns: IUniversalTableColumn[] = [
    {
        type: "text",
        title: "Report ID",
        field: "reportId"
    },
    {
        type: "price",
        title: "Total Amount (excl. VAT)",
        field: "totalAmount"
    },
    {
        type: "dateTime",
        title: "Created on",
        field: "created"
    },
    {
        type: "text",
        title: "User",
        field: "email"
    },
    {
        type: "text",
        title: "BP-ID",
        field: "bpId"
    }
];

const dataExportMapping: IColumnMapping[] = [
    {
        key: "reportId",
        label: "Report ID"
    },
    {
        key: "totalAmount",
        label: "Total Amount (excl. VAT)"
    },
    {
        key: "created",
        label: "Created on",
        mappingFunc: value => convertDateToFullDateTime(value)
    },
    {
        key: "email",
        label: "User"
    },
    {
        key: "bpId",
        label: "BP-ID"
    }
];

const summaryColumns = [
    {
        type: "price",
        title: "Total Amount (excl. VAT)",
        field: "totalAmount"
    },
    {
        type: "text",
        title: "Number of reports",
        field: "noReports"
    },
    {
        type: "text",
        title: "BP-ID",
        field: "bpId"
    }
];

const summaryDataExportMapping: IColumnMapping[] = [
    {
        key: "totalAmount",
        label: "Total Amount (excl. VAT)"
    },
    {
        key: "noReports",
        label: "Number of reports"
    },
    {
        key: "bpId",
        label: "BP-ID"
    }
];

export interface IReportsViewProps extends WithStyles<typeof styles> {
    from?: number;
    to?: number;
    filters?: IStatsFilters;
}

const ReportsViewPure: React.FunctionComponent<IReportsViewProps> = ({
    from,
    to,
    filters,
    classes
}: IReportsViewProps) => {
    const reports = useSelector(state => state.statistics.singleIsinReport);
    return (
        <>
            <HierarchicPieChart
                data={reports?.data as Array<any>}
                levels={["bpId"]}
                aggregationOptions="count"
                title="Reports"
                showBreadcrumbs={true}
                noLegend={true}
            />
            <StatsTable
                dataColumns={dataColumns}
                summaryColumns={summaryColumns}
                data={reports?.data}
                summaryData={reports?.summary}
                exportFilePrefix="reports"
                dataExportMapping={dataExportMapping}
                summaryDataExportMapping={summaryDataExportMapping}
            />
        </>
    );
};

export const ReportsView = withStyles(styles)(ReportsViewPure);
